<app-modal-component [open]="openModal" label="Schedules">
  <div class="cf-shell">
    <app-form-wrapper title="Schedules" (iconClick)="onClose.emit()" icon="close">
      <div class="cf">
        <p class="cf__lead">
          When <strong>{{ subject }}</strong> goes out. Each send reaches the whole audience.
        </p>

        @if (rows.length) {
          <ul class="cf__list">
            @for (row of rows; track row.key) {
              <li class="cf__item">
                <span class="cf__when">
                  <span class="cf__when-main" [attr.title]="row.exact">{{ row.when }}</span>
                  @if (row.sub) {
                    <span class="cf__when-sub">{{ row.sub }}</span>
                  }
                </span>
                @if (row.status) {
                  <app-status [text]="row.status" [status]="row.status" />
                } @else {
                  <span></span>
                }
                <span class="bk-row-actions">
                  <button
                    type="button"
                    class="bk-icon-btn"
                    [attr.aria-label]="'Edit the ' + row.when + ' schedule'"
                    matTooltip="Edit schedule"
                    (click)="row.id ? editingSchedule(row.id) : ''"
                  >
                    <span class="bk-sym" aria-hidden="true">edit</span>
                  </button>
                  <button
                    type="button"
                    class="bk-icon-btn cf__danger"
                    [attr.aria-label]="'Delete the ' + row.when + ' schedule'"
                    matTooltip="Delete schedule"
                    (click)="row.id ? getScheduleToDelete(row.id) : ''"
                  >
                    <span class="bk-sym" aria-hidden="true">delete</span>
                  </button>
                </span>
              </li>
            }
          </ul>
        } @else {
          <p class="cf__empty">No schedules yet. Add one to send this message.</p>
        }

        <!-- add another schedule -->
        <button type="button" class="bk-btn bk-btn--ghost cf__add" (click)="addSchedule()">
          <span class="bk-sym" aria-hidden="true">add</span>
          Add schedule
        </button>

        <div class="cf__foot">
          <customizable-button title="Done" [outline]="true" (click)="onClose.emit()" type="button" />
        </div>
      </div>
    </app-form-wrapper>
  </div>

  @if (editSchedule) {
    <app-edit-schedule
      [openModal]="editSchedule"
      (onClose)="editSchedule = false"
      [scheduleData]="scheduleToEditData"
      [messageSchedules]="message.engagementMessageSchedules"
      [messageId]="message.id"
    ></app-edit-schedule>
  }

  <!-- delete -->
  @if (deleteSchedule) {
    <app-prompt-card
      [openModal]="deleteSchedule"
      title="Delete schedule"
      buttonText="Delete schedule"
      tone="danger"
      closeText="Keep schedule"
      (onClose)="deleteSchedule = false"
      (onButtonClick)="deleteScheduleItem(scheduleToDeleteId)"
      [loading]="campaignsService.isLoading"
    >
      <p class="cf__prompt">
        This send will not go out. Delete the schedule? This cannot be undone.
      </p>
    </app-prompt-card>
  }
</app-modal-component>
